
const getIntValue = (name: string): number | undefined => {
    let value = getStringValue(name)
    return value ? parseInt(value) : undefined
}

const getStringValue = (name: string): string | undefined => new URLSearchParams(window.location.search).get(name) ?? undefined


export const useParamService =  {
    getIntValue: getIntValue,
    getStringValue: getStringValue
}